import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES, HOME_ORDER } from "@/lib/content";

const LAYOUT = ["lg:col-span-6 lg:row-span-2 min-h-[460px]", "lg:col-span-3 min-h-[260px]", "lg:col-span-3 min-h-[260px]", "lg:col-span-3 min-h-[260px]", "lg:col-span-3 min-h-[260px]", "lg:col-span-12 min-h-[300px]"];

export const ServiceCard = ({ k, i, className = "" }) => {
  const svc = SERVICES[k];
  return (
    <motion.div initial={{ opacity: 0, y: 40 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, delay: (i % 3) * 0.08 }} className={className}>
      <Link to={svc.path} className="group relative block h-full min-h-[inherit] rounded-[28px] overflow-hidden bg-noir" data-testid={`service-card-${k}`}>
        <img src={svc.image} alt={svc.title} className="absolute inset-0 w-full h-full object-cover opacity-80 group-hover:scale-105 transition-transform duration-[1200ms]" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent" />
        <span className="absolute top-6 left-7 font-mono text-xs text-white/70">0{i + 1}</span>
        <span className="absolute top-5 right-6 w-9 h-9 rounded-full border border-white/40 grid place-items-center text-white group-hover:bg-white group-hover:text-granate transition-colors"><ArrowUpRight className="w-4 h-4" /></span>
        <div className="absolute bottom-0 inset-x-0 p-7">
          <h3 className="font-display text-4xl sm:text-5xl text-white">{svc.name}</h3>
          <p className="mt-3 text-sm text-white/80">{svc.card || svc.title}</p>
          {svc.children && (
            <div className="mt-5 flex flex-wrap gap-2">
              {svc.children.map((c) => (
                <span key={c} className="rounded-full border border-white/40 px-3 py-1.5 font-brand text-[10px] tracking-[0.15em] uppercase text-white">{SERVICES[c].name}</span>
              ))}
            </div>
          )}
        </div>
      </Link>
    </motion.div>
  );
};

export const Services = () => (
  <section id="servicios" className="py-24 sm:py-32 scroll-mt-24" data-testid="services-section">
    <div className="max-w-[1440px] mx-auto px-5 sm:px-8">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6">
        <div>
          <p className="eyebrow text-granate flex items-center gap-3"><span className="w-8 h-px bg-granate" />Lo que hacemos</p>
          <h2 className="mt-6 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] max-w-3xl" data-testid="services-title">Cinco maneras de estar a la altura</h2>
        </div>
        <p className="max-w-sm text-ink/70 leading-relaxed">Contrata un servicio o confíanos el evento entero. Nos ocupamos de todo, del primer boceto al último brindis, y también de lo que nadie ve.</p>
      </div>
      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 gap-4">
        {HOME_ORDER.map((k, i) => <ServiceCard key={k} k={k} i={i} className={LAYOUT[i]} />)}
      </div>
    </div>
  </section>
);
